<template>
	<el-dialog class="dialog" :title="dialogObj.type==1?'新增':'编辑'" :visible.sync="visiable" width="50%" append-to-body>
		<div v-loading="loading" class="dlalog-body">
			<el-form ref="form" :model="formData" label-width="120px" :rules="rules">
				<el-row>
					<el-col :span="12" v-if="dialogObj.type==2">
						<el-form-item label="ID" prop="id">
							<el-input v-model="formData.id"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="单体名称" prop="name">
							<el-input v-model="formData.name"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="坐标X" prop="pointX">
							<el-input v-model="formData.pointX"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="坐标Y" prop="pointY">
							<el-input v-model="formData.pointY"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="坐标Z" prop="pointZ">
							<el-input v-model="formData.pointZ"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="角度X" prop="rotaX">
							<el-input v-model="formData.rotaX"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="角度Y" prop="rotaY">
							<el-input v-model="formData.rotaY"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="角度Z" prop="rotaZ">
							<el-input v-model="formData.rotaZ"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="缩放X" prop="scaleX">
							<el-input v-model="formData.scaleX"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="缩放Y" prop="scaleY">
							<el-input v-model="formData.scaleY"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="缩放Z" prop="scaleZ">
							<el-input v-model="formData.scaleZ"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="透明度" prop="opacity">
							<el-input v-model="formData.opacity"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="排序" prop="sort">
							<el-input v-model="formData.sort"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="颜色" prop="color">
							<el-color-picker v-model="formData.color"></el-color-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="是否隐藏" prop="isDelete">
							<el-radio-group v-model="formData.isDelete">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="0">否</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="是否有模型" prop="unitShow">
							<el-radio-group v-model="formData.unitShow">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="0">否</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="已关联单体">
							<el-select v-model="formData.unitId" placeholder="请选择" :clearable="true">
								<el-option v-for="item in unitList" :key="item.name" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="说明">
							<el-input v-model="formData.remark"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div class="dialog-footer">
				<el-button @click="close()">关闭</el-button>
				<el-button type="primary" @click="submit()">提交</el-button>
			</div>
		</div>
	</el-dialog>
</template>
<script>
	import {
		dialogMixin
	} from "@m/dialogMixin"
	import configApi from '@config/configApi'
	export default {
		mixins: [dialogMixin],
		data() {
			return {
				formData: {},
				loading: false,
				unitList: [],
				rules: {
					id: {
						required: true,
						message: "此项不能为空",
						trigger: 'blur'
					},
					name: {
						required: true,
						message: "此项不能为空",
						trigger: 'blur'
					},
					modelType: {
						required: true,
						message: "此项不能为空",
						trigger: 'blur'
					},
					pointX: {
						required: true,
						message: "此项不能为空",
						trigger: 'blur'
					},
					pointY: {
						required: true,
						message: "此项不能为空",
						trigger: 'blur'
					},
					pointZ: {
						required: true,
						message: "此项不能为空",
						trigger: 'blur'
					},
					rotaX: {
						required: true,
						message: "此项不能为空",
						trigger: 'blur'
					},
					rotaY: {
						required: true,
						message: "此项不能为空",
						trigger: 'blur'
					},
					rotaZ: {
						required: true,
						message: "此项不能为空",
						trigger: 'blur'
					},
					scaleX: {
						required: true,
						message: "此项不能为空",
						trigger: 'blur'
					},
					scaleY: {
						required: true,
						message: "此项不能为空",
						trigger: 'blur'
					},
					scaleZ: {
						required: true,
						message: "此项不能为空",
						trigger: 'blur'
					},
					opacity: {
						required: true,
						message: "此项不能为空",
						trigger: 'blur'
					},
					sort: {
						required: true,
						message: "此项不能为空",
						trigger: 'blur'
					},
					color: {
						required: true,
						message: "此项不能为空",
						trigger: 'blur'
					},
					unitShow: {
						required: true,
						message: "此项不能为空",
						trigger: 'blur'
					},
					isDelete: {
						required: true,
						message: "此项不能为空",
						trigger: 'blur'
					},
				}
			};
		},
		props: {},
		methods: {
			//打开弹窗
			open() {
				this.formData = {};
				this.$nextTick(() => {
					this.$refs.form.clearValidate();
				})
				this.getunitList();
				if (this.dialogObj.type == 2) {
					this.get();
				}
			},
			getunitList() {
				if (this.dialogObj.lineId) {
					this.loading = true;
					this.$get("/backend-api/web/line/listUnit", {
						line_id: this.dialogObj.lineId
					}).then((res) => {
						if (res.code == 1000) {
							this.unitList = res.data;
							this.loading = false;
						} else {
							this.$message.error(res.msg);
							this.loading = false;
						}
					});
				}
			},
			get() {
				this.$get("/backend-api/model/line-comp/get", {
					id: this.dialogObj.row.id
				}).then((res) => {
					if (res.code == 1000) {
						this.formData = res.data;
						this.formData.color = "#" + this.formData.color;
						this.loading = false;
					} else {
						this.$message.error(res.msg);
						this.loading = false;
					}
				});
			},
			submit() {
				this.$refs["form"].validate((valid) => {
					if (valid) {
						this.formData.unitTypeId = this.dialogObj.unitTypeId;
						if (this.formData.color) {
							this.formData.color = this.formData.color.substring(1);
						}
						this.loading = true;
						this.$postData("/backend-api/model/line-comp/save", this.formData).then((res) => {
							if (res.code == 1000) {
								this.loading = false;
								this.$message.success(res.msg);
								this.$parent.$parent.get();
								this.close();
							} else {
								this.loading = false;
								this.$message.error(res.msg);
							}
						});
					}
				});
			},
			//关闭弹窗
			close() {
				this.loading = false;
				this.visiable = false
			}
		}
	};
</script>
<style lang='scss' scoped>
	.el-dialog {
		min-width: 600px;
	}
</style>
